/* a lirary would be better suited for this, but let's settle for this simple function for now */
export const inflect = (noun: string, criterion: number, basic = true) => {
  /* basic inflection is for nouns that end in s */
  if (basic) {
    return criterion > 1 ? `${noun}s` : noun;
  } else {
    return noun;
  }
};